import './App.css'
import { Switch, Route, BrowserRouter } from 'react-router-dom'

import React, { lazy, Suspense } from 'react'
const Home = lazy(() => import('./components/LandingPage/LandingPage'))

const App = function () {

  React.useEffect(function () {
    document.title = 'Shnuz Fm Radio'
    // eslint-disable-next-line
  }, [])

  return (
    <React.Fragment>
      <Suspense>
        <BrowserRouter>
          <Switch>
            <Route exact path='/' component={Home} />
          </Switch>
        </BrowserRouter>
      </Suspense>
    </React.Fragment>
  )
}

export default React.memo(App)